import React from 'react';
import { Link } from 'react-router-dom';
import { EditorialHero } from './EditorialHero';
import { PageAtmosphereVariant } from './PageAtmosphere';

export function LegalLayout({ title, accent, description, variant, sections, children }: {
  title: string; accent: string; description: string; variant: PageAtmosphereVariant;
  sections: string[]; children: React.ReactNode;
}) {
  return <main className="editorial-page legal-page">
    <EditorialHero eyebrow="Legal & policies" title={title} accent={accent} description={description} variant={variant} href="#policy-content" action="Read the policy" compact />
    <div className="legal-layout" id="policy-content" tabIndex={-1}>
      <aside className="legal-index"><p className="editorial-label">On this page</p>
        <nav aria-label="Policy sections">{sections.map((section, i) => <a key={section} href={`#policy-section-${i + 1}`}>{section}</a>)}</nav>
        <div className="legal-related"><p className="editorial-label">Related policies</p><Link to="/privacy-policy">Privacy policy ↗</Link><Link to="/terms-of-service">Terms of service ↗</Link><Link to="/cookie-policy">Cookie policy ↗</Link><Link to="/ai-disclosure">AI use &amp; limitations ↗</Link></div>
      </aside>
      <div className="legal-body">{children}</div>
    </div>
  </main>;
}
